import { Component } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router, RouterModule, RouterOutlet, Event as RouterEvent } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { TapToTopComponent } from './shared/components/tap-to-top/tap-to-top.component';
import { AuthService } from './shared/services/superadminusers/auth.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, RouterModule, LoaderComponent, TapToTopComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    isLoading: boolean = false;

    constructor(private authService: AuthService, private router: Router) {
        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationStart) {
                this.isLoading = true;
            }
            else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationError
            ) {
                this.isLoading = false;
            }
        });
    }

    ngOnInit() {
        if (!this.authService.isLoggedIn()) {
            this.authService.logout(); // clears token and navigates to login
        }
    }
}